import alertTypeDetailsRedux from 'Modules/alertTypes/views/main/.components/alertTypeDetails/redux/reducer';

//export redux objects
export default {
	alertTypeDetailsRedux,
};